import React from 'react';
import { Card, Typography, Divider, Empty, Spin } from 'antd';
import { CalendarOutlined, EyeOutlined, LikeOutlined, MessageOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import './index.css';

const { Title, Text, Paragraph } = Typography;

const Archive = ({ posts = [] }) => {
  const navigate = useNavigate();

  // 按年份分组文章
  const groupPostsByYear = () => {
    const groups = {};
    
    posts.forEach(post => {
      if (!post.date || !post.isPublished) return;
      
      const year = post.date.split('-')[0];
      if (!groups[year]) {
        groups[year] = [];
      }
      groups[year].push(post);
    });

    // 按年份降序排序
    return Object.entries(groups)
      .sort(([a], [b]) => b - a)
      .reduce((acc, [year, posts]) => {
        // 按日期降序排序
        posts.sort((a, b) => new Date(b.date) - new Date(a.date));
        acc[year] = posts;
        return acc;
      }, {});
  };

  const groupedPosts = groupPostsByYear();

  // 点击文章跳转到详情页
  const handlePostClick = (postId) => {
    navigate(`/post/${postId}`);
  };

  // 如果没有文章
  if (posts.length === 0) {
    return (
      <div className="archive-page">
        <div className="archive-header">
          <Title level={2}>归档</Title>
          <Text type="secondary">所有文章归档</Text>
        </div>
        <div className="archive-content">
          <Empty description="暂无文章" />
        </div>
      </div>
    );
  }

  return (
    <div className="archive-page">
      <div className="archive-header">
        <Title level={2}>归档</Title>
        <Text type="secondary">共 {posts.filter(p => p.isPublished).length} 篇文章</Text>
      </div>

      <div className="archive-content">
        {Object.entries(groupedPosts).map(([year, yearPosts]) => (
          <div key={year} className="year-section">
            <Divider orientation="left">
              <Title level={3} className="year-title">
                {year} 年
                <Text type="secondary" style={{ fontSize: '14px', marginLeft: '8px' }}>
                  ({yearPosts.length} 篇)
                </Text>
              </Title>
            </Divider>

            {yearPosts.map((post, index) => (
              <div 
                key={post.id} 
                className="archive-post-item"
                onClick={() => handlePostClick(post.id)}
              >
                <div className="post-content">
                  <Title level={4} className="post-title">
                    {post.title}
                  </Title>
                  {post.excerpt && (
                    <Paragraph 
                      ellipsis={{ rows: 2 }} 
                      className="post-excerpt"
                    >
                      {post.excerpt}
                    </Paragraph>
                  )}
                  <div className="post-meta">
                    <span className="meta-item">
                      <CalendarOutlined />
                      <Text type="secondary" style={{ marginLeft: '4px' }}>
                        {post.date}
                      </Text>
                    </span>
                    <span className="meta-item">
                      <EyeOutlined />
                      <Text type="secondary" style={{ marginLeft: '4px' }}>
                        {post.views || 0}
                      </Text>
                    </span>
                    <span className="meta-item">
                      <LikeOutlined />
                      <Text type="secondary" style={{ marginLeft: '4px' }}>
                        {post.likes || 0}
                      </Text>
                    </span>
                    <span className="meta-item">
                      <MessageOutlined />
                      <Text type="secondary" style={{ marginLeft: '4px' }}>
                        {post.comments || 0}
                      </Text>
                    </span>
                    {post.tags && post.tags.length > 0 && (
                      <span className="meta-item tags">
                        {post.tags.slice(0, 3).map(tag => (
                          <span key={tag} className="tag">
                            {tag}
                          </span>
                        ))}
                        {post.tags.length > 3 && (
                          <Text type="secondary">...</Text>
                        )}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Archive;